import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/sample_transport_kit/:id',
  title: 'Editar Kits',
  endpoint: '/app/sample_transport_kit',
  breadcrumbs: [],
}
